/*eslint-disable */
// Line 37:  Seems to not like the creation of an array, and then I populate it if data exists, with a foreach loop and
// return the array.

// Line 63:  Does not like prop spreading line 63
import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApolloOptionsQuery } from '../../hoc/apolloWrapper/index';
import { SCHOOL_QUERY, MAJORS_QUERY } from '../../apollo/queries';
import { AutoComplete } from './index';
import formatString from '../../utils/stringFormatUtils';

interface Props {
  onClick: (enabled: object) => void;
  classes: any;
  enabled?: boolean;
  error?: boolean;
  value: string;
  optionsFilter: string;
  setOptionsQuery: (val: string) => void;
  items: any;
  label: string;
  placeholder?: string;
  name: string;
  onChange?: (e: object) => void;
  onType?: (val: string) => void;
  defaultValue?: DefaultValue;
  locId?: number;
  isMultiSelect?: boolean;
  hideInputBox?: boolean;
}

interface DefaultValue {
  label: string;
  value: string;
}

const asyncAutoComplete: FC<Props> = (props: Props) => {
  const [showDefaults, setShowDefaults] = useState(false);
  const dataMapCallback = ({ error, loading, data }: any) => {
    const items: any[] = [];
    // Remove college board and populate the items array

    switch (props.name) {
      case 'major':
        data?.majors?.forEach((major: any) => {
          items.push({
            value: major.title,
            label: major.title,
          });
        });
      case 'school':
      default:
        data?.schools?.schools?.forEach((school: any) => {
          if (school.name.toLocaleLowerCase() !== 'college board') {
            // This prevents the adding of 'College Board' to the dropdown
            let cityStateLabel = ` (${school.city}, ${school.state})`;
            if (school.city == null || school.city == '')
              cityStateLabel = ` (${school.state})`;
            if (school.state == null || school.state == '')
              cityStateLabel = ` (${school.city})`;
            if (
              (school.city == null || school.city == '') &&
              (school.state == null || school.state == '')
            )
              cityStateLabel = '';
            items.push({
              value: school.code,
              label: school.name + cityStateLabel,
            });
          }
        });
        if (
          props.optionsFilter &&
          props.optionsFilter.length >= 3 &&
          items.length === 0
        )
          setShowDefaults(true);
        else setShowDefaults(false);
    }
    return { items, error: props.error, loading, queryError: { ...error } };
  };

  const whichQuery = (fieldId: string) => {
    switch (fieldId) {
      case 'major':
        return MAJORS_QUERY;
      case 'school':
      default:
        return SCHOOL_QUERY;
    }
  };

  const canExecuteQueryCheck = (fieldId: string, queryString: string) => {
    switch (fieldId) {
      case 'major':
        return true;
      case 'school':
      default:
        if (queryString && queryString.length >= 3) return true;
        return false;
    }
  };

  const whichVariables = (fieldId: string) => {
    switch (fieldId) {
      case 'major':
        return { searchTerm: props.optionsFilter, locId: props.locId };
      case 'schools_interested':
        return {
          queryString: props.optionsFilter,
          visitorType: 'college_grad',
        };
      case 'school':
      default:
        return { queryString: props.optionsFilter, visitorType };
    }
  };

  const shouldAllowDropdown = (fieldId: string) => {
    switch (fieldId) {
      case 'major':
        return true;
      case 'school':
      default:
        return false;
    }
  };

  // Pull the visitorType from formState
  const visitorType = useSelector(
    ({ formState }: any) => formState.visitortype
  );
  const onType = (val: any) => {
    if (val !== undefined) props.setOptionsQuery(val);
  };
  return (
    <ApolloOptionsQuery
      queryString={whichQuery(props.name)}
      variables={whichVariables(props.name)}
      dataMapCallback={dataMapCallback}
      canExecuteQuery={canExecuteQueryCheck(props.name, props.optionsFilter)}
      withDebounceMS={750}
    >
      <AutoComplete
        useDefaultValues={showDefaults}
        onType={onType}
        {...props}
        allowDropdown={shouldAllowDropdown(props.name)}
        isMultiSelect={props.isMultiSelect}
        hideInputBox={props.hideInputBox}
        defaultValue={props.value}
      />
    </ApolloOptionsQuery>
  );
};

export default asyncAutoComplete;
try {
    // @ts-ignore
    asyncAutoComplete.displayName = "asyncAutoComplete";
    // @ts-ignore
    asyncAutoComplete.__docgenInfo = { "description": "", "displayName": "asyncAutoComplete", "props": { "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": true, "type": { "name": "(enabled: object) => void" } }, "classes": { "defaultValue": null, "description": "", "name": "classes", "required": true, "type": { "name": "any" } }, "enabled": { "defaultValue": null, "description": "", "name": "enabled", "required": false, "type": { "name": "boolean" } }, "error": { "defaultValue": null, "description": "", "name": "error", "required": false, "type": { "name": "boolean" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "string" } }, "optionsFilter": { "defaultValue": null, "description": "", "name": "optionsFilter", "required": true, "type": { "name": "string" } }, "setOptionsQuery": { "defaultValue": null, "description": "", "name": "setOptionsQuery", "required": true, "type": { "name": "(val: string) => void" } }, "items": { "defaultValue": null, "description": "", "name": "items", "required": true, "type": { "name": "any" } }, "label": { "defaultValue": null, "description": "", "name": "label", "required": true, "type": { "name": "string" } }, "placeholder": { "defaultValue": null, "description": "", "name": "placeholder", "required": false, "type": { "name": "string" } }, "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": false, "type": { "name": "(e: object) => void" } }, "onType": { "defaultValue": null, "description": "", "name": "onType", "required": false, "type": { "name": "(val: string) => void" } }, "defaultValue": { "defaultValue": null, "description": "", "name": "defaultValue", "required": false, "type": { "name": "DefaultValue" } }, "locId": { "defaultValue": null, "description": "", "name": "locId", "required": false, "type": { "name": "number" } }, "isMultiSelect": { "defaultValue": null, "description": "", "name": "isMultiSelect", "required": false, "type": { "name": "boolean" } }, "hideInputBox": { "defaultValue": null, "description": "", "name": "hideInputBox", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/autoComplete/asyncAutoComplete.tsx#asyncAutoComplete"] = { docgenInfo: asyncAutoComplete.__docgenInfo, name: "asyncAutoComplete", path: "src/components/autoComplete/asyncAutoComplete.tsx#asyncAutoComplete" };
}
catch (__react_docgen_typescript_loader_error) { }